import React from 'react'
import { OutboundLink } from 'gatsby-plugin-gtag'
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText,
  EuiIcon
} from '@elastic/eui'


export default function softwareVideos() {

  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="esQdkQvb5uo"
                    title="INSTAR IN-9008 FullHD Kamera"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              footer={
                <EuiText>
                <p>In diesem Video zeigen wir Ihnen die neue INSTAR FUll HD Kamera (Modell IN-9008). Die einzigartige neue Kamera kommt ohne Anschlusskabel und man hat so die Möglichkeit nur die Kabel ins innere der Kamera zu führen die man auch wirklich benötigt. Zudem kommt die Kamera mit einem sehr sehr hochwertigen Panasonic WDR Bildsensor als auch einem eingebauten Panasonic PIR Wärmesensor. Es ist zudem ein Mikrofon bereits eingebaut. Diese hardwareseitigen Features machen die IN-9008 Full HD zu einer der besten Überwachungskameras die es aktuell auf dem Markt gibt.</p>
                <p>Überzeugen Sie sich jetzt selbst und bestellen Sie Ihre IN-9008 Full HD direkt bei INSTAR. Auf <OutboundLink href="https://www.youtube.com/watch?v=ckKuHQFU-Pc" target="_blank" rel="noopener noreferrer">Youtube ansehen <EuiIcon type="popout" /></OutboundLink></p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}